import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import B2bFirmUserTableFilter from "../Filters/B2bFirmUserTableFilter";
import B2bFirmUserAddForm from "../Forms/B2bFirmUserAddForm";
import B2bFirmUserUpdateForm from "../Forms/B2bFirmUserUpdateForm";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  Tag,
  Tooltip,
  notification,
  Menu,
  Dropdown,
  Spin,
  message,
} from "antd";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  MailOutlined,
  CreditCardOutlined,
  SyncOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import config from "../../util/ApiforContext";

const FirmUser = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [isUseVknInsteadOfEmail, setIsUseVknInsteadOfEmail] = useState(true);
  const [selectedResetAll, setSelectedResetAll] = useState(null);
  const [isB2BFirmTransaction, setIsB2BFirmTransaction] = useState({
    data: false,
    loading: false,
  });

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  useEffect(() => {
    getTenantParameter();
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response)
        setIsB2BFirmTransaction({
          data: response.isB2BFirmTransaction,
          loading: false,
        });
    });
  }, []);

  const getTableData = () => {
    const { skip, take, filter } = tableDataQueryOptions;

    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.get(
      `/TenantFirmUser?$count=true${filter}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const renderChecked = (data, row) => {
    return data ? (
      <CheckCircleOutlined style={{ color: "green", fontSize: "130%" }} />
    ) : (
      <CloseCircleOutlined style={{ color: "red", fontSize: "130%" }} />
    );
  };

  const onClickChangeStatus = (id, isActive) => {
    RequestHandler.post("/TenantFirmUser/ChangeStatus", {
      id,
      isActive: !isActive,
    }).then((response) => {
      if (response?.success) {
        getTableData();
      }
    });
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/TenantFirmUser/GetById/${record.id}`).then(
      (response) => {
        if (response) {
          setUpdateFormData(response);
          setUpdateFormVisibility(true);
        }
      }
    );
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/TenantFirmUser/${id}`).then((response) => {
      if (response?.success) {
        getTableData();
      }
    });
  };

  const onAddSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const onUpdateSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const sendCreatePasswordEmail = (tenantFirmUserId) => {
    RequestHandler.post(
      "/TenantFirmUser/SendCreatePasswordMail/" + tenantFirmUserId
    );
  };

  const getColumns = () => {
    if (isB2BFirmTransaction.data) {
      columns.splice(16, 0, {
        title: "Ekstre Dökümü",
        dataIndex: "firmTransaction",
        align: "center",
        render: renderChecked,
      });
    }
    return columns;
  };
  const columns = [
    {
      title: "Tahsilat",
      dataIndex: "createPayment",
      render: (data, row) => {
        return (
          <a href={"pos-collection/" + row.firmId}>
            <CreditCardOutlined style={{ fontSize: 19 }} />
          </a>
        );
      },
    },
    {
      title: "Bayi Kodu",
      dataIndex: "firmCode",
    },
    {
      title: "Bayi Ünvanı",
      dataIndex: "firmName",
    },
    {
      title: isUseVknInsteadOfEmail ? "Vkn / Tckn" : "E-posta",
      dataIndex: "email",
    },
    {
      title: "Bayi VKN / TCKN",
      dataIndex: "firmVknTckn",
      render: (data, row) => data ?? "-",
    },
    {
      title: "Telefon Numarası",
      dataIndex: "phoneNumber",
    },
    {
      title: "Pos Tahsilatı",
      dataIndex: "posCollection",
      align: "center",
      render: renderChecked,
    },
    {
      title: "İptal/İade Talebi Alma",
      dataIndex: "cancelRefundRequestIsOpen",
      align: "center",
      render: renderChecked,
    },
    {
      title: "Link Oluşturma",
      dataIndex: "createPaymentLink",
      align: "center",
      render: renderChecked,
    },
    {
      title: "Alt Bayi Ekleme",
      dataIndex: "addSubFirm",
      align: "center",
      render: renderChecked,
    },
    {
      title: "Ödeme Planı",
      dataIndex: "paymentPlan",
      align: "center",
      render: renderChecked,
    },
    {
      title: "Tahsilat Planı",
      dataIndex: "collectionPlan",
      align: "center",
      render: renderChecked,
    },
    {
      title: "Dbs Faturalar",
      dataIndex: "dbsInvoices",
      align: "center",
      render: renderChecked,
    },
    {
      title: "Fatura İskontolama",
      dataIndex: "invoiceDiscount",
      align: "center",
      render: renderChecked,
    },
    {
      title: "Erp Rapor",
      dataIndex: "erpReport",
      align: "center",
      render: renderChecked,
    },
    {
      title: "Stoklar",
      dataIndex: "stocks",
      align: "center",
      render: renderChecked,
    },
    {
      title: "Şifre Durumu",
      dataIndex: "isPasswordCreated",
      align: "center",
      render: (isPasswordCreated, row, index) => {
        let color = isPasswordCreated ? "green" : "orange";
        let text = isPasswordCreated ? "Oluşturuldu" : "Bekliyor";
        return <Tag color={color}>{text}</Tag>;
      },
    },
    {
      title: "Şifre Maili",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isPasswordCreated ? null : (
          <Popconfirm
            title="Kullanıcıya tekrar şifrenizi oluşturun maili yollamak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={(e) => sendCreatePasswordEmail(data)}
          >
            <Button type="link" style={{ marginBottom: 0 }}>
              <MailOutlined style={{ fontSize: "130%" }} />
            </Button>
          </Popconfirm>
        ),
    },
    {
      title: "Durum",
      dataIndex: "isActive",
      align: "center",
      render: (text, row) => {
        const { title, icon } = row.isActive
          ? {
              title: "Kullanıcıyı pasif etmek istiyor musunuz?",
              icon: (
                <Tooltip title="Pasif et">
                  <CheckCircleOutlined
                    style={{ color: "green", fontSize: "130%" }}
                  />
                </Tooltip>
              ),
            }
          : {
              title: "Kullanıcıyı aktif etmek istiyor musunuz?",
              icon: (
                <Tooltip title="Aktif Et">
                  <CloseCircleOutlined
                    style={{ color: "red", fontSize: "130%" }}
                  />
                </Tooltip>
              ),
            };
        return (
          <Popconfirm
            title={title}
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => onClickChangeStatus(row.id, row.isActive)}
          >
            <a>{icon}</a>
          </Popconfirm>
        );
      },
    },
    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) => (
        <a onClick={() => handleOnClickUpdate(row)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (data, record) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a>
            <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const openNotificationCheckWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description:
        "Senkronizasyon talebiniz başarıyla alınmıştır.Bu işlem bir kaç dakika sürebilir.Firma kullanıcılarınızın durumunu bu ekrandan takip edebilirsiniz.",
      duration: 10,
    });
  };

  const onConfirmSync = () => {
    if (selectedResetAll !== null) {
      RequestHandler.post(
        "/TenantFirmUser/SynchronizeTenantFirmUsers",
        { resetAllTenantFirmUserTenantUsers: selectedResetAll },
        false
      ).then(() => {
        openNotificationCheckWithIcon("success");
      });
      setSelectedResetAll(null);
    }
  };

  const handleMenuClick = (resetAll) => {
    setSelectedResetAll(resetAll);
  };

  const getTenantParameter = () => {
    RequestHandler.get("/TenantParameter/GetByTenant").then((response) => {
      if (response) {
        setIsUseVknInsteadOfEmail(response.isUseVknInsteadOfEmailForB2B);
      }
    });
  };

  const syncMenu = (
    <Menu>
      <Menu.Item key="1" onClick={() => handleMenuClick(false)}>
        Standart Senkronizasyon
      </Menu.Item>
      <Menu.Item key="2" onClick={() => handleMenuClick(true)}>
        Tüm Kullanıcıları Sıfırla ve Senkronize Et
      </Menu.Item>
    </Menu>
  );

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);

    RequestHandler.post(
      `/TenantFirmUser/ExportExcel`,
      {
        query: tableDataQueryOptions.filter,
      },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${
            config.apiUrl
          }/TenantFirmUser/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  return (
    <>
      <Row align="middle">
        <Col xs={24} md={12} lg={15}>
          <p style={{ fontSize: "120%", marginBottom: 0 }}>
            <BarsOutlined /> FİRMA KULLANICI TANIMLARI
          </p>
        </Col>
        <Col
          xs={24}
          md={6}
          lg={5}
          style={{
            textAlign: "right",
            marginRight: "inherit",
            marginLeft: "unset",
            marginTop: "0.8%",
          }}
        >
          <Dropdown overlay={syncMenu} placement="bottomRight">
            <Button>
              <SyncOutlined /> Kullanıcı Senkronizasyonu
            </Button>
          </Dropdown>

          {/* Kullanıcı bir seçenek seçtiğinde onay penceresi çıkar */}
          <Popconfirm
            title="Senkronizasyon işlemini onaylıyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            visible={selectedResetAll !== null}
            onConfirm={onConfirmSync}
            onCancel={() => setSelectedResetAll(null)}
          />
        </Col>

        <Col xs={24} md={3} lg={2} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setAddFormVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Kullanıcı Ekle
          </Button>
        </Col>
        <Col xs={24} md={3} lg={2} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 30,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
        </Col>
      </Row>

      <B2bFirmUserTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          {isB2BFirmTransaction.loading ? (
            <Spin spinning={true} />
          ) : (
            <Table
              columns={getColumns()}
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
              rowKey="id"
              filterable={true}
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              dataSource={tableData.data}
              loading={tableData.loading}
              size="small"
            />
          )}
        </Col>
      </Row>

      <Drawer
        id="addPaymentDrawer"
        title="Kullanıcı Tanımı Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <B2bFirmUserAddForm
          onSuccess={onAddSuccess}
          isUseVknInsteadOfEmail={isUseVknInsteadOfEmail}
        />
      </Drawer>

      <Drawer
        id="updatePaymentDrawer"
        title="Kullanıcı Tanımı Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <B2bFirmUserUpdateForm
          data={updateFormData}
          onSuccess={onUpdateSuccess}
          isUseVknInsteadOfEmail={isUseVknInsteadOfEmail}
        />
      </Drawer>
    </>
  );
};

export default FirmUser;
